// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_ValidateSetupResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /contas/validate_setup/{id}
 *
 * The `dados` payload IS the flat validation block — the per-account
 * setup-validation shape exactly as Contas_model::validate_setup() returns it
 * (mirrors Contas_ContaValidationRow).
 *
 * Uses the default getDados() (no override): the public typed properties below
 * ARE the dados object, so the generated runtime schema validates every field.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Contas_ValidateSetupResponseDados {
is_complete: boolean
is_active: boolean
has_payment_methods: boolean
has_users: boolean
issues: string[]
}

export type Contas_ValidateSetupResponse = ApiResponse<Contas_ValidateSetupResponseDados>;

registerResponseContract('Contas_ValidateSetupResponse', {
  is_complete:         { type: 'boolean', required: true },
  is_active:           { type: 'boolean', required: true },
  has_payment_methods: { type: 'boolean', required: true },
  has_users:           { type: 'boolean', required: true },
  issues:              { type: 'array',   required: true },
})
